import { render, staticRenderFns } from "./TechnicalData.vue?vue&type=template&id=2d872194&"
import script from "./TechnicalData.vue?vue&type=script&lang=js&"
export * from "./TechnicalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports